'use strict';

const axios = require('axios').default;

function getSettings() {
  return axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/settings/${config.projectGuid}`);
}
function getProps() {
  return axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/props/${config.projectGuid}`);
}

/**
 * Get dictionary json file from CDN repository
 * Returns promise
 */
export const getDictionary = () => {
  return axios.get(`${config.cdnRepository}/${config.projectFolder}/config/dictionary.json`, {headers: {'Content-Type': 'application/json'}});
};

const getPoi = () => {
  return axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/poi/${config.projectGuid}`);
}

const getPoiCategories = () => {
  return axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/poicategories/${config.projectGuid}`);
}

const getAboutData = () =>{
  return axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/about/${config.projectGuid}`);
}

const getGalleryData = () =>{
  return axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/gallery/${config.projectGuid}`)
}

export const getContactsData = () =>{
  return axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/contacts/${config.projectGuid}`)
};

export const getLoaderData = () =>{
  return axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/loader/${config.projectGuid}`)
};

//essential API data
export function getCrmData () {
  return Promise.all([getSettings(), getProps()/*, getDictionary()*/]);
}

// poi API data
export function getPoiData(){
  return Promise.all([getPoi(), getPoiCategories()]);
}

export function getWidgetsData () {
  return Promise.all([getAboutData(),getGalleryData()]);
}
